/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * What the analyst answered about this company on this day.
 */
export type DailyNavDeliveryReview = {
  /**
   * Whether the checklist is fully answered under the firm's `monitoring_mode`. Read this rather than re-deriving it: the required answers differ between modes, and a fund-managed row is complete without the analyst checkbox or a note.
   */
  is_complete: boolean;
  /**
   * A Scalar analyst signed this row off. Required for completion only when `monitoring_mode` is `scalar_managed`; a fund-managed row may leave it false.
   */
  reviewed_by_scalar: boolean;
  /**
   * When that answer was last recorded, in UTC. Null if never set.
   */
  reviewed_by_scalar_at: string | null;
  /**
   * The advisor's sign-off. Required for completion in BOTH monitoring modes -- it is the answer that survives when the Scalar checkbox does not.
   */
  discussed_with_fund: boolean;
  /**
   * When that answer was last recorded, in UTC. Null if never set.
   */
  discussed_with_fund_at: string | null;
  /**
   * Whether the review concluded the price should change. Three-valued: null means nobody has answered yet, which is an unfinished review rather than a 'no'. A `false` is a complete, valid answer -- nothing requires an adjustment.
   */
  price_adjusted: boolean | null;
  /**
   * Which session a 'yes' was promised for, and required alongside one: `today` revalues before this day is filed, `next_day` defers it, so this day reports the carried-forward price and the obligation lands on the next session's record. Null whenever `price_adjusted` is not true.
   */
  price_adjustment_timing: DailyNavDeliveryReview.price_adjustment_timing | null;
  /**
   * When the price answer was last recorded, in UTC.
   */
  price_adjusted_at: string | null;
  /**
   * True when this day OPENED owing a price, because a previous session's review deferred one onto it. Pinned at generation, so it describes the obligation the day inherited rather than its current state -- `status` reports whether that obligation was discharged.
   */
  pending_price_adjustment: boolean;
  /**
   * Analyst notes left on this row, oldest first, exactly as written. Nothing system-generated is added. Notes can be added after finalization.
   */
  notes: Array<string>;
};
export namespace DailyNavDeliveryReview {
  /**
   * Which session a 'yes' was promised for, and required alongside one: `today` revalues before this day is filed, `next_day` defers it, so this day reports the carried-forward price and the obligation lands on the next session's record. Null whenever `price_adjusted` is not true.
   */
  export enum price_adjustment_timing {
    TODAY = 'today',
    NEXT_DAY = 'next_day',
  }
}

